const EJenisBadanUsaha= Object.freeze([

    {
        id: 1,
        description: 'Non Badan Usaha',
    },
    {
        id: 2,
        description: 'CV (Persekutuan Komanditer)',
    },
    {
        id: 3,
        description: 'PT (Perseroan Terbatas)',
    },

])

export  { EJenisBadanUsaha  as default}